import "./_style.less";
import clsx from "clsx";
import { ReactNode } from "react";

interface SessionCardProps {
  label: ReactNode;
  discount?: number;
  isActive?: boolean;
  onClick?: () => void;
}

const SessionCard = (props: SessionCardProps) => {
  return (
    <div
      onClick={props.onClick}
      className={clsx("session-card", {
        selected: props.isActive,
      })}
    >
      <div className="session-card-label">{props.label}</div>
      {props.discount && props.discount > 0 && (
        <div className="session-card-discount">
          <span className="session-card-discount-text">Disc</span>
          <span className="session-card-discount-value">{props.discount}%</span>
        </div>
      )}
    </div>
  );
};

export default SessionCard;
